export const SITE_URL = 'https://bullishaccounting.com';
export const LANGS = ['en', 'es'];

export const SERVICE_KEYS = ['strategic', 'international', 'realestate', 'business', 'accounting'];
export const AUDIENCE_KEYS = ['investors', 'owners'];

export const PATHS = {
  home: { en: '/en/', es: '/es/' },
  investors: { en: '/en/who-we-serve/international-investors/', es: '/es/a-quien-servimos/inversionistas-internacionales/' },
  owners: { en: '/en/who-we-serve/business-owners/', es: '/es/a-quien-servimos/duenos-de-negocios/' },
  expertise: { en: '/en/expertise/', es: '/es/servicios/' },
  strategic: { en: '/en/expertise/strategic-tax-planning/', es: '/es/servicios/planificacion-fiscal-estrategica/' },
  international: { en: '/en/expertise/international-cross-border-tax/', es: '/es/servicios/impuestos-internacionales/' },
  realestate: { en: '/en/expertise/us-investment-real-estate-tax/', es: '/es/servicios/inversion-y-bienes-raices/' },
  business: { en: '/en/expertise/business-tax-compliance/', es: '/es/servicios/impuestos-empresariales/' },
  accounting: { en: '/en/expertise/accounting-advisory/', es: '/es/servicios/contabilidad-y-asesoria/' },
  plans: { en: '/en/accounting-plans/', es: '/es/planes-contables/' },
  howWeWork: { en: '/en/how-we-work/', es: '/es/como-trabajamos/' },
  about: { en: '/en/about/', es: '/es/nosotros/' },
  insights: { en: '/en/insights/', es: '/es/insights/' },
  book: { en: '/en/book-a-strategy-session/', es: '/es/agendar-sesion-estrategica/' },
  privacy: { en: '/en/privacy/', es: '/es/privacidad/' },
  terms: { en: '/en/terms/', es: '/es/terminos/' },
  disclaimer: { en: '/en/disclaimer/', es: '/es/aviso-profesional/' },
  review: { en: '/en/review/', es: '/es/review/' },
};

export const TESTIMONIALS_ANCHOR = { en: 'testimonials', es: 'comentarios' };

export const LEGACY_HASHES = {
  '#inicio': '/es/',
  '#servicios': PATHS.expertise.es,
  '#comentarios': '/es/#comentarios',
  '#nosotros': PATHS.about.es,
  '#contacto': PATHS.book.es,
};

const normalize = (p) => (p.endsWith('/') ? p : `${p}/`);

export const findPage = (pathname) => {
  const path = normalize(pathname);
  for (const [key, byLang] of Object.entries(PATHS)) {
    for (const lang of LANGS) {
      if (byLang[lang] === path) return { key, lang };
    }
  }
  return null;
};

export const langFromPath = (pathname) => (pathname.startsWith('/es') ? 'es' : 'en');

export const path = (key, lang) => PATHS[key][lang];
